const publicVariable = {
  
// 求援管理的故障位置一致含9个系统
  abortSituationOptions: [
    { label: '燃料动力附件系统装置', value: 0 },
    { label: '电子牵引系统装置', value: 1 },
    { label: '动力冷却及空气调节系统装置', value: 2 },
    { label: '底盘系统装置', value: 3 },
    { label: '安全系统装置', value: 4 },
    { label: '娱乐、信息与控制系统装置', value: 5 },
    { label: '常规电子电气系统装置', value: 6 },
    { label: '车身系统装置', value: 7 },
    { label: '内外饰及附件系统装置', value: 8 }
  ]
}

export default
{
  publicVariable
}

